import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../components/checkbox/CheckBox";
import Utils from "../../../../../../utils/Utils";


class EsitoFollowUp extends Component {

    state = {
        esitoFollowUp: {
            presenzaEsito: 0,
            guarigione: 0,
            decesso: 0,
            dataGuarigione: "",
            dataDecesso: "",
            dettaglioEsiti: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.checkGuarigione = this.checkGuarigione.bind(this);
        this.checkDecesso = this.checkDecesso.bind(this);
        this.changeEsiti = this.changeEsiti.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp) {
            let esito = this.state.esitoFollowUp
            let propsEsito = this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp
            esito.decesso = propsEsito.decesso ? propsEsito.decesso : 0
            esito.guarigione = propsEsito.guarigione ? propsEsito.guarigione : 0
            esito.presenzaEsito = propsEsito.presenzaEsito ? propsEsito.presenzaEsito : 0
            esito.dataDecesso = propsEsito.dataDecesso ? propsEsito.dataDecesso : ""
            esito.dataGuarigione = propsEsito.dataGuarigione ? propsEsito.dataGuarigione : ""
            esito.dettaglioEsiti = propsEsito.dettaglioEsiti ? propsEsito.dettaglioEsiti : ""
            this.setState({esitoFollowUp: esito})
        }
        this.controllaDati();
        this.props.setEsitoFollowUp(this.state.esitoFollowUp)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati()
        if (prevState !== this.state) {
            let res = this.createJsonForBackend();
            this.props.setEsitoFollowUp(this.state.esitoFollowUp, this.validate(), res)
        }
    }

    validate() {

        if (this.state.esitoFollowUp.dataDecesso) {
            let validatedataDecesso = Utils.checkDateInterval(this.state.esitoFollowUp.dataDecesso, "31/12/1899");
            let validatedataDecessoOdierna = Utils.checkDateInterval(this.state.esitoFollowUp.dataDecesso, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDecesso) {
                return "Messages.DataDecesso"
            } else if (!validatedataDecessoOdierna) {
                return "Messages.DataDecessoOdierna"
            }
        }
        if (this.state.esitoFollowUp.dataGuarigione) {
            let validatedataGuarigione = Utils.checkDateInterval(this.state.esitoFollowUp.dataGuarigione, "31/12/1899");
            let validatedataGuarigioneOdierna = Utils.checkDateInterval(this.state.esitoFollowUp.dataGuarigione, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataGuarigione) {
                return "Messages.DataGuarigione"
            } else if (!validatedataGuarigioneOdierna) {
                return "Messages.DataGuarigioneOdierna"
            }
        }

        if (this.state.esitoFollowUp.presenzaEsito === 0 && this.state.esitoFollowUp.dettaglioEsiti) return "Messages.ERR_01_02_0C_AA"
        if (this.state.esitoFollowUp.guarigione === 0 && this.state.esitoFollowUp.dataGuarigione) return "Messages.ERR_01_02_0C_AB"
        if (this.state.esitoFollowUp.decesso === 0 && this.state.esitoFollowUp.dataDecesso) return "Messages.ERR_01_02_0C_AC"

        return ""

    }

    createJsonForBackend() {
        let dati = this.state.esitoFollowUp
        let ObjectForBackEnd = {}
        ObjectForBackEnd["presenzaEsito"] = dati.presenzaEsito
        ObjectForBackEnd["guarigione"] = dati.guarigione
        ObjectForBackEnd["decesso"] = dati.decesso
        ObjectForBackEnd["dataGuarigione"] = dati.dataGuarigione
        ObjectForBackEnd["dataDecesso"] = dati.dataDecesso
        ObjectForBackEnd["dettaglioEsiti"] = dati.dettaglioEsiti

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    controllaDati() {
        let dati = this.state.esitoFollowUp
        dati.corretto = []

        if (dati.guarigione === 1 && (!dati.dataGuarigione || (dati.dataGuarigione && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataGuarigione), "-")))) dati.corretto[0] = "Campo \"Guarigione - Data\" mancante o errato";
        if (dati.decesso === 1 && (!dati.dataDecesso || (dati.dataDecesso && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataDecesso), "-")))) dati.corretto[1] = "Campo \"Decesso - Data\" mancante o errato";
        if (dati.presenzaEsito === 1 && !dati.dettaglioEsiti) dati.corretto[2] = "Campo \"Presenza esiti - Specificare\" mancante";

    }

    checkGuarigione() {
        let esitoFollowUp = this.state.esitoFollowUp
        if (esitoFollowUp.guarigione === 0) {
            esitoFollowUp.guarigione = 1
            esitoFollowUp.decesso = 0
            esitoFollowUp.dataDecesso = ""
        } else {
            esitoFollowUp.guarigione = 0
            esitoFollowUp.dataGuarigione = ""
        }
        this.setState({esitoFollowUp: esitoFollowUp})
    }

    checkDecesso() {
        let esitoFollowUp = this.state.esitoFollowUp
        if (esitoFollowUp.decesso === 0) {
            esitoFollowUp.decesso = 1
            esitoFollowUp.guarigione = 0
            esitoFollowUp.dataGuarigione = ""
        } else {
            esitoFollowUp.decesso = 0
            esitoFollowUp.dataDecesso = ""
        }
        this.setState({esitoFollowUp: esitoFollowUp})

    }

    changeEsiti() {
        let esitoFollowUp = this.state.esitoFollowUp
        if (esitoFollowUp.presenzaEsito === 1) {
            esitoFollowUp.presenzaEsito = 0
        } else {
            esitoFollowUp.presenzaEsito = 1

        }
        this.setState({esitoFollowUp: esitoFollowUp})
    }

    riceviValoreRadioButton(event, field) {
        let esitoFollowUp = this.state.esitoFollowUp
        esitoFollowUp[field] = event
        this.setState({esitoFollowUp: esitoFollowUp})
    }

    riceviValoreInput(field, event) {

        let esitoFollowUp = this.state.esitoFollowUp
        if (field.currentTarget) {
            esitoFollowUp[field.currentTarget.id] = field.currentTarget.value
        } else {
            esitoFollowUp[field] = event.target.value
        }
        this.setState({esitoFollowUp: esitoFollowUp})
    }

    render() {

        const {t} = this.props

        return (<div style={{marginTop: "20px"}}>
            <div>
                <h6>{t("SchedaInfluenzaGrave.esitoFollowup")}</h6>
                <hr className={styles.hr}/>
            </div>
            <div className={"container"}>

                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <p style={{marginTop: "10px"}}><b>{t("SchedaInfluenzaGrave.esito")}:</b></p>

                    </div>

                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <RadioButton id={"guarigione"} name={"guarigione"}
                                     label={t("SchedaInfluenzaGrave.guarigione")}
                                     style={{color: "black"}}
                                     onClick={this.checkGuarigione}
                                     checked={this.state.esitoFollowUp.guarigione === 1}
                        />
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-lg-1">
                            </div>
                            <div className="col-lg-3">

                                <p style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.data")}: {this.state.esitoFollowUp.guarigione === 1 ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}</b></p>
                            </div>
                            <div className="col-lg-8">
                                <Calendar id={"dataGuarigione"}
                                          value={this.state.esitoFollowUp.dataGuarigione}
                                          field={"dataGuarigione"}
                                          onChange={this.riceviValoreInput}
                                          errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                              "Data")}
                                          error={(this.state.esitoFollowUp.dataGuarigione === "" ||
                                              this.state.esitoFollowUp.dataGuarigione == null) ? false :
                                              Utils.isDateInValid(Utils.transformDateForBackend(this.state.esitoFollowUp.dataGuarigione), "-")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <RadioButton id={"decesso"} name={"decesso"}
                                     label={t("SchedaInfluenzaGrave.decesso")}
                                     style={{color: "black"}}
                                     onClick={this.checkDecesso}
                                     checked={this.state.esitoFollowUp.decesso === 1}
                        />
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-lg-1">
                            </div>
                            <div className="col-lg-3">

                                <p style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.data")}: {this.state.esitoFollowUp.decesso === 1 ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}</b></p>
                            </div>
                            <div className="col-lg-8">
                                <Calendar id={"dataDecesso"}
                                          value={this.state.esitoFollowUp.dataDecesso}
                                          field={"dataDecesso"}
                                          onChange={this.riceviValoreInput}
                                          errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                              "Data")}
                                          error={(this.state.esitoFollowUp.dataDecesso === "" ||
                                              this.state.esitoFollowUp.dataDecesso == null) ? false :
                                              Utils.isDateInValid(Utils.transformDateForBackend(this.state.esitoFollowUp.dataDecesso), "-")}

                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <CheckBox id={"presenzaEsito"}
                                  isRadio={false}
                                  checked={this.state.esitoFollowUp.presenzaEsito.checked}
                                  fontColor={"black"}
                                  defaultChecked={this.props.segnalazioneCopia.schedaSpeciale
                                      && this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp
                                      && this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp.presenzaEsito && this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp.presenzaEsito === 1}
                                  newCheckbox={true}
                                  text={t("SchedaInfluenzaGrave.presenzaEsiti")}
                                  onChange={this.changeEsiti}
                        >
                        </CheckBox>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-1" style={{marginLeft: "30px"}}>
                                <p style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.specificare")}:{this.state.esitoFollowUp.presenzaEsito === 1 ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}</b></p>
                            </div>
                            <div className="col-lg-8">
                                <Input id={"dettaglioEsiti"}
                                       field={"dettaglioEsiti"}
                                       type={"textarea"}
                                       value={this.state.esitoFollowUp.dettaglioEsiti}
                                       placeholder={"Dettaglio"}
                                       onChange={this.riceviValoreInput}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }


}


export default withTranslation('common')(EsitoFollowUp)
